import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { useI18n } from '../i18n';
import en from './terms/en';
import pt from './terms/pt';
import es from './terms/es';
import zh from './terms/zh';

// One file per language under ./terms, same blocks in the same order (check with
// `node src/pages/terms/check.cjs <lang>`). The text is ours and static, so its
// <strong>, <em> and <a> tags are rendered as HTML.
const TERMS = { en, pt, es, zh };

const Html = ({ as: Tag, html }) => <Tag dangerouslySetInnerHTML={{ __html: html }} />;

const Terms = () => {
  const { lang } = useI18n();
  const terms = TERMS[lang] || en;

  return (
    <div className="lb-page relative w-full px-2 py-8 sm:px-4 sm:py-12">
      <div className="relative mx-auto w-full max-w-4xl">
        <Link to="/" className="lb-btn lb-btn-ghost lb-btn-sm mb-6">
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          {terms.ui.back}
        </Link>

        <div className="lb-shell">
          <header className="flex items-center gap-4 border-b border-white/5 px-5 py-6 sm:px-10">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-white/5">
              <FileText className="h-6 w-6 text-brand-periwinkle" aria-hidden="true" />
            </div>
            <div>
              <p className="lb-eyebrow">{terms.ui.eyebrow}</p>
              <h1 className="lb-heading mt-1 text-2xl sm:text-3xl">{terms.ui.title}</h1>
            </div>
          </header>

          <div className="lb-legal px-5 py-8 sm:px-10 sm:py-10">
            {terms.blocks.map((block, index) =>
              block.tag === 'ul' ? (
                <ul key={index}>
                  {block.items.map((item, itemIndex) => (
                    <Html key={itemIndex} as="li" html={item} />
                  ))}
                </ul>
              ) : (
                <Html key={index} as={block.tag} html={block.html} />
              )
            )}
            <p>
              <em>{terms.ui.updated}</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
